<template>
  <div class="home">
    <div class="hidden lg:block p-5 bg-gray-100 ml-16 float-right w-1/3">
      <p>
        We are a team of researchers and students at Brown, MIT, Harvard, Mass
        General and elsewhere.
      </p>
      <p>
        <strong>Emily Oster</strong> is an American economist, professor at
        Brown University, and bestselling author.
      </p>
      <p>
        <strong>Galit Alter</strong> is a Professor of Medicine at Harvard
        Medical School and a Group Leader at the Ragon Institute of MGH, MIT and
        Harvard.
      </p>
    </div>

    <div class="preamble">
      <p class="text-2xl md:text-3xl">
        <strong>COVID-19 is confusing.</strong> We are here with facts about the
        virus. How does it spread? How is it treated? Who does it affect most?
        Unbiased information to help you make good decisions.
      </p>
    </div>
    <div class="block lg:hidden p-5 bg-gray-100 lg:w-1/4">
      <p>
        We are a team of researchers and students at Brown, MIT, Harvard, Mass
        General and elsewhere.
      </p>
      <p>
        <strong>Emily Oster</strong> is an American economist, professor at
        Brown University, and bestselling author.
      </p>
      <p>
        <strong>Galit Alter</strong> is a Professor of Medicine at Harvard
        Medical School and a Group Leader at the Ragon Institute of MGH, MIT and
        Harvard.
      </p>
    </div>
    <!-- <div class="search-bar">
              <input type="text" v-model="searchTerm" placeholder="Search" />
    </div>-->

    <div class="clear"></div>

    <div class="md:flex">
      <div class="w-full md:w-1/2">
        <h2 class="text-2xl mt-12 mb-2 font-bold no-underline">
          <router-link :to="{ name: 'Topic', params: { topicName: 'news' } }">
            News in Context
          </router-link>
        </h2>

        <div class="flex flex-wrap bg-white">
          <div
            class="news-item relative my-2 md:pr-16"
            v-bind:class="post.topic"
            v-for="(post, i) in filteredNewsPosts.slice(0, 4)"
            :key="i"
          >
            <i
              v-if="authAdmin"
              class="material-icons edit"
              @click="redirectToEditPost(post.id)"
              >edit</i
            >

            <router-link
              class="news-link"
              :to="{
                name: 'Post',
                params: { postId: post.id, slug: post.slug },
              }"
            >
              <p class="explainer-title  text-2xl underline-purple">
                {{ post.title }}
              </p>
            </router-link>
          </div>
        </div>
        <router-link
          class="text-sm font-bold mt-6 block"
          :to="{ name: 'Topic', params: { topicName: 'news' } }"
        >
          <span>View all...</span>
        </router-link>
        <router-link
          v-if="authAdmin"
          :to="{ name: 'SelectHomeItems', params: { topicName: 'news' } }"
        >
          <button class="bg-black font-bold text-white p-4 text-xs mt-4">
            Select featured news items
          </button>
        </router-link>
      </div>

      <div class="w-full  md:w-1/2">
        <h2 class="text-2xl mt-12 mb-4 font-bold no-underline">
          <router-link
            :to="{ name: 'Topic', params: { topicName: 'questions' } }"
          >
            How do I...
          </router-link>
        </h2>

        <div>
          <div
            class="question-item relative mt-2 mb-4"
            v-bind:class="post.topic"
            v-for="(post, i) in filteredQuestionPosts.slice(0, 4)"
            :key="i"
          >
            <i
              v-if="authAdmin"
              class="material-icons edit"
              @click="redirectToEditPost(post.id)"
              >edit</i
            >

            <router-link
              class="text-2xl underline-orange"
              :to="{
                name: 'Post',
                params: { postId: post.id, slug: post.slug },
              }"
            >
              {{ post.title }}
            </router-link>
          </div>
        </div>
        <router-link
          class="text-sm font-bold mt-8 block"
          :to="{ name: 'Topic', params: { topicName: 'questions' } }"
        >
          <span>View all...</span>
        </router-link>
        <router-link
          v-if="authAdmin"
          :to="{ name: 'SelectHomeItems', params: { topicName: 'questions' } }"
        >
          <button class="bg-black font-bold text-white p-4 text-xs mt-4">
            Select featured news items
          </button>
        </router-link>
      </div>
    </div>

    <div class="block">
      <h2 class="text-2xl mt-16 mb-8 font-bold no-underline">
        <router-link
          :to="{ name: 'Topic', params: { topicName: 'explainers' } }"
          >Getting more in depth.
        </router-link>
      </h2>

      <div class="flex flex-wrap">
        <div
          class="w-full sm:w-1/2 bg-white"
          :class="post.topic"
          v-for="(post, i) in filteredExplainerPosts"
          :key="i"
        >
          <div class="explainer-item relative border-b mb-4 md:mr-16 py-2">
            <i
              v-if="authAdmin"
              class="material-icons edit"
              @click="redirectToEditPost(post.id)"
              >edit</i
            >

            <router-link
              class="block"
              :to="{
                name: 'Post',
                params: { postId: post.id, slug: post.slug },
              }"
            >
              <p class="explainer-title mb-2 text-2xl underline-teal">
                {{ post.title }}
              </p>
              <p
                class="font-light no-underline explainer-subtitle text-gray-600 text-md"
              >
                {{ post.subtitle }}
              </p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <router-link
      class="text-sm font-bold mt-4 block"
      :to="{ name: 'Topic', params: { topicName: 'explainers' } }"
    >
      <span>View all...</span>
    </router-link>
  </div>
</template>

<script>
import db from '@/firebase/init';
import firebase from 'firebase';
export default {
  name: 'Home',
  data() {
    return {
      posts: null,
      searchTerm: '',
      authAdmin: {},
      dbAdmin: {},
    };
  },

  computed: {
    filteredPosts: function() {
      let postsFilteredByTitle = this.posts.filter(post => {
        return post.title.toLowerCase().match(this.searchTerm.toLowerCase());
      });
      let postsFilteredByContent = this.posts.filter(post => {
        return post.text.toLowerCase().match(this.searchTerm.toLowerCase());
      });
      let combinedArr = postsFilteredByTitle.concat(postsFilteredByContent);
      let deduplicatedArr = this.deduplicateById(combinedArr);
      return deduplicatedArr;
    },
    filteredExplainerPosts: function() {
      return this.filteredPosts.filter(post => post.topic === 'explainers');
    },
    filteredDefintionsPosts: function() {
      return this.filteredPosts.filter(post => post.topic === 'definitions');
    },
    filteredNewsPosts: function() {
      let filteredNewsPosts = this.filteredPosts.filter(post => {
        if (post.topic === 'news' && post.displayOnHome === true) {
          return post;
        }
      });
      return filteredNewsPosts;
    },
    filteredQuestionPosts: function() {
      let filteredNewsPosts = this.filteredPosts.filter(post => {
        if (post.topic === 'questions' && post.displayOnHome === true) {
          return post;
        }
      });
      return filteredNewsPosts;
    },
  },
  methods: {
    deduplicateById(arr) {
      var obj = {};
      var stop = arr.length;
      for (var i = 0, len = stop; i < len; i++) {
        obj[arr[i]['id']] = arr[i];
      }
      let arr2 = new Array();
      for (var key in obj) {
        if (key !== 'undefined') {
          arr2.push(obj[key]);
        }
      }
      return arr2;
    },

    setAdminIfLoggedIn() {
      let authAdmin = firebase.auth().currentUser;
      firebase.auth().onAuthStateChanged(admin => {
        if (admin) {
          this.authAdmin = admin;
          this.checkApprovalStatus(this.authAdmin.uid);
        } else {
          this.authAdmin = null;
        }
      });
    },
    checkApprovalStatus(adminId) {
      db.collection('users')
        .doc(adminId)
        .get()
        .then(doc => {
          let dbAdmin = doc.data();
          dbAdmin.id = doc.id;
          this.dbAdmin = dbAdmin;
        });
    },

    redirectToEditPost(postId) {
      this.$router.push({
        name: 'EditPost',
        params: {
          postId: postId,
        },
      });
    },
    getPosts() {
      if (this.posts === null) {
        this.posts = [];
      }
      db.collection('posts')
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let post = doc.data();
            post.id = doc.id;
            this.posts.push(post);
          });
        });
    },
  },

  filters: {
    createSnippet: function(value) {
      if (!value) {
        value = '';
      } else if (value.length > 50) {
        value = value.substring(0, 50) + '...';
      }
      return value;
    },
  },
  created() {
    this.getPosts();
    this.setAdminIfLoggedIn();
  },
};
</script>

<style scoped>
.home {
  padding: 0 20px;
}

.edit {
  position: absolute;
  top: 4px;
  right: 4px;
}

.edit:hover {
  opacity: 0.5;
  cursor: pointer;
}

.preamble {
  max-width: 1280px;
  font-weight: 100;
  padding: 1rem 0 2rem 0;
}

.explainer-item a,
.news-item a,
.no-underline a {
  text-decoration: none;
}

.clear {
  clear: both;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue